export default "__VITE_ASSET__JXzOslfI4vc8COVOfdwF1w__"